import * as React from 'react'
import classNames from 'classnames'
import { IPaymentSourceResponseDTO } from '../../../../types'
import moment from 'moment'
import UIMessages from 'src/utils/ui-messages'
import { Link } from 'react-router-dom'
export interface IPaymentMethodItemProps {
  method: IPaymentSourceResponseDTO
  riderId: string
  onSelectPaymentMethod: (method: IPaymentSourceResponseDTO) => void
  removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => void
}

class PaymentMethodItem extends React.Component<IPaymentMethodItemProps, any> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const { method, riderId, removeRiderPaymentSource } = this.props
    const cardExpiry = moment(`${this.props.method.exp_year}-${this.props.method.exp_month}-28`).endOf('month')
    const allowance = moment().add(2, 'months')
    const expired = cardExpiry < moment()
    const classes = classNames('rounded mt1 mr1 p2 box-shadow', {
      'bg-light-grey2': method.isDefault && !expired,
      'border-grey': !method.isDefault && !expired,
      'bg-light-red': expired
    })
    return (
      <div className={classes}>
        <div className='mb1'>
          {/* TODO: Add a proper rendering to credit cards' icon */}
          <span className={this.props.method.isDefault ? 'bold font-grey2 h5' : 'font-grey3 h5'}>
            {method.isDefault ? 'Primary' : 'Secondary'}
          </span>{' '}
          &nbsp;
          <br />
          <br />
          <span className={this.props.method.isDefault ? 'bold font-grey2 h5' : 'font-grey3 h5'}>
            {method.name}
          </span>{' '}
          &nbsp;
          {cardExpiry <= allowance && cardExpiry >= moment() && (
            <span className='bold font-red'>{`${UIMessages.rider.payment.nearingExpiry} ${cardExpiry.fromNow()}`}</span>
          )}
          {expired && <span className='bold font-red'>{`${UIMessages.rider.payment.expired}`}</span>}
          &nbsp;
          <br />
          {expired && (
            <button
              className='btn bg-green rounded font-white weight-300'
              onClick={() => removeRiderPaymentSource(method.id, riderId)}
            >
              <Link to={`/riders/${riderId}/edit/wallet`}>{UIMessages.common.update} card</Link>
            </button>
          )}
        </div>
        <div className='flex'>
          <div className='CCNumber font-grey3 h5'>**** **** **** {this.props.method.last4}</div>
          <div style={{ flex: 1 }}>&nbsp;</div>
          <div className='ml3 font-grey3 h5'>
            {`Exp Date: ${this.props.method.exp_month
              .toString()
              .padStart(2, '0')}/${this.props.method.exp_year.toString().substring(2)}`}
          </div>
          <div style={{ flex: 1 }}>&nbsp;</div>
        </div>
      </div>
    )
  }

  private onSelect = () => {
    this.props.onSelectPaymentMethod(this.props.method)
  }
}

export default PaymentMethodItem



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/PaymentMethodItem.tsx